<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.authorized_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Autorizar docente</v-toolbar-title>
            </v-toolbar>

            <v-container>
                <v-form ref="authorized" v-on:submit.prevent="submit($event)">
                    <v-row>
                        <v-col cols="12" lg="6" md="10" class="mx-auto">
                            <v-subheader class="px-0">Información personal</v-subheader>
                            <v-divider class="mb-4"></v-divider>

                            <v-menu
                                ref="menu"
                                :color="color"
                                :header-color="color"
                                v-model="birthdate_dialog"
                                :close-on-content-click="false"
                                :return-value.sync="birthdate"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="birthdate" :rules="[rules.required]" filled :color="color" label="Fecha de nacimiento" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="birthdate" color="#008dd4" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text :color="color" @click="birthdate_dialog = false">Cancelar</v-btn>
                                    <v-btn color="#008dd4" @click="$refs.menu.save(birthdate)">Aceptar</v-btn>
                                </v-date-picker>
                            </v-menu>

                            <v-text-field v-model="curp" filled label="CURP" :rules="[rules.required, rules.curp_length]" :color="color" clearable></v-text-field>
                            <v-text-field v-model="rfc" filled label="RFC" :rules="[rules.rfc_length]" :color="color" clearable></v-text-field>
                            <v-text-field type="number" v-model="professional_license" filled label="Cedula profesional" :rules="[rules.professional_license_length]" :color="color"></v-text-field>

                            <v-subheader class="px-0">Domicilio</v-subheader>
                            <v-divider class="mb-4"></v-divider>

                            <v-text-field v-model="street" filled label="Calle" :rules="[rules.required]" :color="color" clearable></v-text-field>
                            <v-text-field v-model="neighborhood" filled label="Colonia" :color="color" clearable></v-text-field>
                            <v-select v-model="state" filled :rules="[rules.required]" label="Estado" :color="color" :item-color="color" :items="states" item-text="nombre" item-value="nombre"></v-select>
                            <v-select v-model="municipality" filled :rules="[rules.required]" label="Municipio" :color="color" :item-color="color" :items="municipalities[state]" item-text="nombre" item-value="nombre" no-data-text="Seleccione un estado"></v-select>
                            <v-row no-gutters>
                                <v-text-field type="number" min="0" v-model="external_number" filled label="Número exterior" :rules="[rules.required]" :color="color"></v-text-field>
                                <v-text-field v-model="internal_number" filled label="Número interior" :color="color"></v-text-field>
                            </v-row>
                            <v-text-field v-model="zipcode" type="number" filled :rules="[rules.required, rules.zipcode]" label="Código postal" :color="color"></v-text-field>
                            <v-file-input v-model="proof_ine" filled label="INE" :color="color" :rules="[rules.required]"></v-file-input>
                            <v-file-input v-model="proof_address" filled label="Comprobante de domicilio" :color="color" :rules="[rules.required]"></v-file-input>
                            <v-file-input v-model="proof_professional" filled label="Comprobante de cedula profesional" :color="color"></v-file-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg="6" md="10" class="text-right mx-auto">
                            <v-btn type="submit" :loading="loading" color="#008dd4" dark>Autorizar</v-btn>
                            <v-btn @click="cancel" :disabled="loading" text>Cancelar</v-btn>
                        </v-col>
                    </v-row>
                </v-form>

            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'
import _states from '../../assets/states.json'
import _municipalities from '../../assets/municipalities.json'

export default {
    props:['dialog','item','store_url'],
    data: () => ({
        //props
        color:"#000",
        states: _states,
        municipalities: _municipalities,
        loading:false,

        //elements models
        birthdate_dialog: false,

        //rules
        rules:{
            required: v => !!v || 'El campo es requerido',
            curp_length: v  => !!v && v.length >= 18 || 'Debe contener 18 caracteres',
            rfc_length: v => !v || v.length >= 12 && v.length <= 13 || 'Debe contener al menos 12 caracteres y máximo 13',
            professional_license_length: v => !v || v.length >= 7 || 'Debe contener al menos 7 digitos',
            zipcode: v => !!v && v.length == 5 || 'Debe contener 5 digitos'
        },

        //models
        birthdate:"",
        curp:"",
        rfc:"",
        professional_license:"",
        street:"",
        neighborhood:"",
        state:"",
        municipality:"",
        external_number:"",
        internal_number:"",
        zipcode:"",
        proof_ine:[],
        proof_address:[],
        proof_professional:[],
    }),

    methods:{

        submit:function(){
            if(this.$refs.authorized.validate()){
                let data = new FormData()
                data.append("user_id", this.item.id)
                data.append("birthdate", this.birthdate)
                data.append("curp", this.curp)
                data.append("rfc", this.rfc)
                data.append("professional_license", this.professional_license)
                data.append("street", this.street)
                data.append("neighborhood", this.neighborhood)
                data.append("state", this.state)
                data.append("municipality", this.municipality)
                data.append("external_number", this.external_number)
                data.append("internal_number", this.internal_number)
                data.append("zipcode", this.zipcode)
                data.append("proof_ine", this.proof_ine)
                data.append("proof_address", this.proof_address)
                data.append("proof_professional", this.proof_professional)

                this.loading = true

                axios.post(this.store_url, data).then(response => {
                    this.cancel()
                    iziToast.success({
                        title:"Correcto",
                        position:"topRight",
                        message:"El Docente fue autorizado correctamente"
                    })

                    this.$parent.getData()


                }).catch(error => {
                    this.loading = false
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }
                })
            }
        },

        cancel:function(){
            this.loading = false
            this.$refs.authorized.reset()
            this.$parent.authorized_dialog = false
        }
    }
}
</script>
